import { z } from 'zod';
import { MAX_MATCH_RADIUS_KM } from '../constants.js';
import { LEAD_TYPES } from '../enums.js';
import {
  emailSchema,
  optionalShortText,
  paginationSchema,
  phoneSchema,
  postalCodeSchema,
  searchSchema,
  uuid,
} from './common.js';

/** Leads visible to the signed-in partner, filtered server-side by assignment. */
export const partnerLeadListQuerySchema = paginationSchema.extend({
  type: z.enum(LEAD_TYPES).optional(),
  search: searchSchema,
  /** Hide leads this partner has already quoted. */
  withoutOffer: z.coerce.boolean().optional(),
});

export const updatePartnerProfileSchema = z.object({
  companyName: optionalShortText(160),
  phone: phoneSchema.optional(),
  alternatePhone: phoneSchema.optional(),
  contactEmail: emailSchema.optional(),
  streetNumber: optionalShortText(120),
  postalCode: postalCodeSchema.optional(),
  address: optionalShortText(255),
  latitude: z.coerce.number().min(-90).max(90).optional(),
  longitude: z.coerce.number().min(-180).max(180).optional(),
  matchRadiusKm: z.coerce.number().int().min(1).max(MAX_MATCH_RADIUS_KM).optional(),
  logoAssetId: uuid.optional(),
  agentImageAssetId: uuid.optional(),
});

export const postalCodeLookupSchema = z.object({
  postalCode: postalCodeSchema,
});

export type UpdatePartnerProfileInput = z.infer<typeof updatePartnerProfileSchema>;
